import { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CadviewerContext } from "../../context/Cadviewer.Context";
import useConfig from "../../demos/hooks/useConfig";

export const ValidateEmail = () => {
  const { config } = useConfig();
  const { token } = useParams();
  const navigate = useNavigate();
  const { setUser } = useContext(CadviewerContext);
  const [isLoading, setIsLoading] = useState(true);
  const [status, setStatus] = useState<{
    success: boolean;
    message: string;
  } | null>(null);

  const validateEmail = useCallback(async () => {
    try {
      const response = await fetch(
        `${config.ServerBackEndUrl}${
          config.ServerBackEndUrl.endsWith("/") ? "" : "/"
        }auth/validate-email/${token}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      const data = await response.json();

      if (!response.ok) {
        setStatus({
          success: false,
          message: data.error,
        });
        // navigate("/");
        return;
      }

      setStatus({
        success: true,
        message: data.message,
      });
      setUser(data.data);
      localStorage.setItem("auth_user", JSON.stringify(data.data));
      navigate("/");
    } catch (error) {
      console.error(error);
      setStatus({
        success: false,
        message: "An error occurred while validating the email",
      });
      // navigate("/");
    } finally {
      setIsLoading(false);
    }
  }, [token, navigate, setUser]);

  useEffect(() => {
    validateEmail();
  }, [validateEmail]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="text-center p-10 bg-white">
          <div className="mb-6">
            <div className="animate-pulse inline-block">
              <svg
                className="w-16 h-16 text-orange-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
            </div>
          </div>
          <h1 className="text-3xl font-bold mb-4 text-gray-800 animate-pulse">
            Validation of your email in progress...
          </h1>
          <div className="flex justify-center items-center space-x-2">
            <div className="w-3 h-3 bg-orange-600 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
            <div className="w-3 h-3 bg-orange-600 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
            <div className="w-3 h-3 bg-orange-600 rounded-full animate-bounce"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center p-8 bg-white max-w-md w-full mx-4">
        <div
          className={`text-6xl mb-4 ${
            status?.success ? "text-green-500" : "text-red-500"
          }`}
        >
          {status?.success ? "✓" : "✗"}
        </div>
        <h1
          className={`text-2xl font-bold mb-4 ${
            status?.success ? "text-green-700" : "text-red-700"
          }`}
        >
          {status?.success
            ? "Email validated successfully!"
            : "Validation failed"}
        </h1>
        <p className="text-gray-600 mb-6">{status?.message}</p>
        <button
          onClick={() => navigate("/")}
          className="px-6 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors"
        >
          Back to home
        </button>
      </div>
    </div>
  );
};
